export const STATUS = Object.freeze({
  ALL:0,
  PENDING: 1,
  APPROVED: 2,
  RESERVED: 3,
  DELIVERED: 4,
  RESEIVED: 5,
  DENIED: 6
}) 